import { Box, Typography } from "@mui/material";
import axios from "axios";
import Footer from "components/Footer";
import PageDefaultLayout from "components/LayoutContainers/PageDefaultLayout/pageDefaultLayout";
import LoadingCircle from "components/LoadingCircle/loadingCircle";
import { setAnotherPage, useMaterialUIController } from "context";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  AlertState,
  DataCountryState,
  DataNationState,
  DataProvinceState,
  DataTypeOwnerState,
} from "states";
import { API_ROUTES, APP_URL } from "../../utils/constants";
import FormDangKyChuThe from "./formDangKyChuThe";
import { DataStatusState } from "states";

const SignOwner = () => {
  const navigate = useNavigate();

  const optionProvince = useRecoilValue(DataProvinceState);
  const setAlert = useSetRecoilState(AlertState);

  const [controller, dispatch] = useMaterialUIController();

  const optionDanToc = useRecoilValue(DataNationState);
  const optionQuocGia = useRecoilValue(DataCountryState);
  const optionLoaiHinh = useRecoilValue(DataTypeOwnerState);
  const optionTrangThai = useRecoilValue(DataStatusState);

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setAnotherPage(dispatch, true);
  }, []);

  const handleToSubmitData = async (data) => {
    const keysResgiter = [
      "first_name",
      "last_name",
      "username",
      "password",
      "email",
      "repassword",
      "birth_date",
      "is_active",
      "gender",
      "address",
      "maquan",
      "matinh",
      "maphuong",
      "donvi",
    ];
    const keysOwner = [
      "ma",
      "ten",
      "email",
      "dienthoai",
      "diachi",
      "maphuong",
      "maquan",
      "matinh",
      "loaihinh",
      "ngaycap",
      "coquancap",
      "nguoidaidienphapluat",
      "nguoidaidienphapluat_email",
      "nguoidaidienphapluat_diachi",
      "nguoidaidienphapluat_dienthoai",
      "nguoidaidienphapluat_chucvu",
      "gioitinh",
      "quocgia",
      "ngaysinh",
      "dantoc",
      "socccd",
      "ngaycap_cccd",
      "noicap_cccd",
      "ghichu",
      "solaodongquanly",
      "solaodongsanxuat",
      "trangthai",
    ];
    const dataRegister = Object.fromEntries(
      Object.entries(data).filter(([key]) => keysResgiter.includes(key))
    );
    const dataOwner = Object.fromEntries(
      Object.entries(data).filter(([key]) => keysOwner.includes(key))
    );
    setLoading(true);
    await axios
      .post(
        API_ROUTES.REGISTER,
        { ...dataRegister, group: [5], is_active: "False", domain: APP_URL },
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .then((res) => {
        axios.post(
          API_ROUTES.QUANLYCHUTHE,
          {
            username: res?.data?.username,
            ...dataOwner,
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        setAlert({
          alert: true,
          message: "Đã đăng ký thành công!",
          type: "success",
        });
        const timer = setTimeout(() => {
          navigate("/sign-in"); // Chuyển hướng tới trang chủ sau khi tắt thông báo
        }, 3000); // Thời gian hiển thị thông báo (3000ms = 3 giây)
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((error) => {
        setAlert({
          alert: true,
          message: error?.message,
          type: "error",
        });
        console.log(error);
        return;
      });
  };
  return (
    <PageDefaultLayout>
      <Box
        sx={{
          height: "85vh",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          component={"h4"}
          textAlign={"center"}
          fontSize={"1.5rem"}
          fontWeight={"600"}
          marginBottom={"1rem"}
        >
          Đăng ký chủ thể
        </Typography>

        {loading ? (
          <div className="flex-1 flex items-center justify-center">
            <LoadingCircle size={50} />
          </div>
        ) : (
          <FormDangKyChuThe
            dataTinh={optionProvince}
            dataDantoc={optionDanToc}
            dataQuocgia={optionQuocGia}
            dataLoai={optionLoaiHinh}
            dataTrangThai={optionTrangThai}
            onSubmit={handleToSubmitData}
          />
        )}
      </Box>
      <Footer />
    </PageDefaultLayout>
  );
};

export default SignOwner;
